// utils/calendar.js
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// format wymagany przez Google Calendar: YYYYMMDDTHHMMSSZ
function formatForGoogleCalendar(date) {
  return dayjs(date).utc().format("YYYYMMDD[T]HHmmss[Z]");
}

export function getGoogleCalendarUrl(event) {
//   if (!event.start_raw) return "#";

  const start = event.start_raw || event.start_datetime;
  const endIso =
    event.end_raw || dayjs(start).add(2, "hour").toISOString(); // domyślnie +2h

  const dates = `${formatForGoogleCalendar(start)}/${formatForGoogleCalendar(
    endIso
  )}`;

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: event.title || event.name || "",
    dates,
    details: event.description || "",
    location: event.place || event.address || "",
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
